import {FeatureCollection, Polygon} from "geojson"
import {Polygon as OLPolygon} from "ol/geom"
import {Feature} from "ol"
import {GeoJSON} from "ol/format"
import {TNavObject} from "@ui/api/features"
import popupService from "./PopupService"
import {LayerId} from "./"
import FeatureService from "./FeatureService"
import association from "./Association"

export interface IPolygonService {
  addPolygon<T extends TNavObject>(polygons: FeatureCollection<Polygon, T>, layerId: LayerId): void
  toggleLayer(isVisible: boolean): void
}

export class PolygonService extends FeatureService implements IPolygonService {
  polygonLayers = [LayerId.ACHARE]

  private constructPolygonPopup(feature: Feature<OLPolygon>, name: string) {
    const featureProps = feature.getProperties()
    return FeatureService.constructFeaturePopup([
      {
        name,
        obj: featureProps,
        propNames: [
          {name: "obj_name", hasNational: true, isDictionary: true},
          {name: "information", hasNational: true, isDictionary: true},
          {name: "anchorage_category", isDictionary: true}
        ]
      }
    ])
  }

  addPolygon<T extends TNavObject>(polygons: FeatureCollection<Polygon, T>, layerId: LayerId): void {
    const formatter = new GeoJSON()
    let features = formatter.readFeatures(polygons) as Feature<OLPolygon>[]
    if (features.length > 0) {
      features = features.map(feature => {
        feature.set("onClick", () => {
          const association_ids = feature.getProperties().association_ids
          popupService.showPopup(
            feature,
            this.constructPolygonPopup(feature, layerId),
            association_ids && association_ids.length > 0
              ? association.cancelAssociation.bind(association)
              : () => feature.setProperties({selected: false})
          )
          if (association_ids && association_ids.length > 0) association.selectAssociation(association_ids)
          else feature.setProperties({selected: true})
        })
        return feature
      })
      FeatureService.addFeatures(layerId, features)
    }
  }

  toggleLayer(isVisible: boolean) {
    this.polygonLayers.forEach(layerId => FeatureService.getLayer(layerId)?.setVisible(isVisible))
  }
}

export default new PolygonService() as IPolygonService
